module.exports = __webpack_public_path__ + "static/img/qrcode-wx-yoyo.896de96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode-wx-yoyo.png
// module id = r5Tb
// module chunks = 0